import fr from './fr.json'
import en from './en.json'

export default {
    fr,
    en
}



// WEBPACK FOOTER //
// ./src/wording/index.js